import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FlatPickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  setValueModeleInvestissement,
  setCategorieModeleInvestissement,
  setActifModeleInvestissement,
  setCurrentPageModeleInvestissement,
  setOrderModeleInvestissement,
  setSortFieldModeleInvestissement,
  setTypeModeleInvestissement,
} from "../../store/actions";
import Config from "config";
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "../../components/Common/DeleteModal";
import ReactPaginate from "react-paginate";
import DeleteButton from "components/Common/DeleteButtonList";

//redux

import { useSelector, useDispatch } from "react-redux";
import { Col, Row, Card, CardBody } from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import useDebounce from "../Investor/useDebounce";
import { useNavigate } from "react-router-dom";
import LastModificationAlert from "components/Common/Alert";

function ModeleInvestissementList() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [modelInvestissementData, setModelInvestissement] = useState([]);
  const token = localStorage.getItem("auth_token_" + api);
  const [redirectToLoginPage, setRedirect] = useState(false);
  const [wait, setWait] = useState(400);
  // Pagination

  const currentPage = useSelector(
    (state) => state.FiltreModelInvestissement.currentPage
  );
  const itemsPerPage = 20; // Limite d'affichage par page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //   const currentItems = modelInvestissementData.slice(indexOfFirstItem, indexOfLastItem);
  //Recherche
  const value = useSelector((state) => state.FiltreModelInvestissement.value);

  const type = useSelector((state) => state.FiltreModelInvestissement.type);
  const actif = useSelector((state) => state.FiltreModelInvestissement.actif);
  const categorie = useSelector(
    (state) => state.FiltreModelInvestissement.categorie
  );

  const debounceSearch = useDebounce(value, 500);
  // Triage
  const handleSorting = async (sortField, sortOrder) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/publipostages_investissements?page=${currentPage}&sort_by=${sortField}_${sortOrder}&key=${debounceSearch}&types_publipostage_id=${type}&actif=${actif}&natures_investissement_id=${categorie}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newData = await response.json();
      const upData = newData;
      setModelInvestissement(upData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  //Thead
  const sortField = useSelector(
    (state) => state.FiltreModelInvestissement.sortField
  );
  const order = useSelector((state) => state.FiltreModelInvestissement.order);
  const [isSorting, setIsSorting] = useState(false);
  const handleSortingChange = (accessor) => {
    dispatch(setCurrentPageModeleInvestissement(1));
    setIsSorting(true);
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";

    dispatch(setSortFieldModeleInvestissement(accessor));
    dispatch(setOrderModeleInvestissement(sortOrder));

    handleSorting(accessor, sortOrder); // Appel à la fonction de tri
    setIsSorting(false);
  };

  //meta title
  document.title = "Modèles Investissement | DOM COM";

  useEffect(() => {
    if (redirectToLoginPage == true) {
      localStorage.removeItem("auth_token_" + api);
      localStorage.removeItem("authUser_" + api);
      localStorage.removeItem("sideBar_" + api);
      history(`${backUrl}/login`);
      window.location.reload(false);
    }
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, [redirectToLoginPage, history]);
  //page change
  const fetchPage = async (currentPage) => {
    try {
      const res = await fetch(
        `https://www.fluxod.com/${api}/publipostages_investissements?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&types_publipostage_id=${type}&actif=${actif}&natures_investissement_id=${categorie}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error fetching page: ", error);
    }
  };

  const handlePageChange = async (data) => {
    let currentPage = data.selected + 1;
    const getData = await fetchPage(currentPage);
    dispatch(setCurrentPageModeleInvestissement(currentPage));
    setModelInvestissement(getData);
  };
  // Filtre

  // Mettre à jour les paramètres de filtre et déclencher la fonction de filtrage avec débordement

  // Fonction pour mettre à jour l'état du filtre et appeler la mise à jour des paramètres accumulés
  const handleFilterChange = (accessor, value) => {
    const updatedFilters = modelInvestissementData.filters.map((filter) => {
      if (filter.accessor === accessor) {
        return {
          ...filter,
          value: value,
        };
      }
      return filter;
    });

    setModelInvestissement((prevData) => ({
      ...prevData,
      filters: updatedFilters,
    }));

    // Mettre à jour les paramètres de filtre
  };

  // La fonction de filtrage reste inchangée, elle utilise les paramètres de filtre accumulés
  const handleFiltering = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/publipostages_investissements?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&types_publipostage_id=${type}&actif=${actif}&natures_investissement_id=${categorie}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }

      //   if (!response.ok) {
      //     redirectToLoginPage = true;

      //     throw new Error("La réponse du réseau n'est pas valide");
      //   }

      const newData = await response.json();
      setModelInvestissement(newData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données : ", error);
    }
  };

  const renderFilters = () => {
    const handleFilterValidation = () => {
      handleFiltering(modelInvestissementData.filters);
    };

    return (
      <>
        {!loading ? (
          <>
            {modelInvestissementData?.filters?.map((filter, index) => {
              switch (filter.accessor) {
                case "key":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <input
                        defaultValue={value}
                        className="form-control mb-3 mb-xxl-0"
                        type="text"
                        placeholder={filter.label}
                        onChange={(e) => {
                          dispatch(
                            setValueModeleInvestissement(e.target.value)
                          );
                          dispatch(setCurrentPageModeleInvestissement(1));
                          handleFilterChange(filter.accessor, value);
                        }}
                      />
                    </Col>
                  );
                case "types_publipostage_id":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        defaultValue={type}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setTypeModeleInvestissement(e.target.value)),
                            dispatch(setCurrentPageModeleInvestissement(1));
                          handleFilterChange(filter.accessor, type);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "actif":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        defaultValue={actif}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(
                            setActifModeleInvestissement(e.target.value)
                          ),
                            dispatch(setCurrentPageModeleInvestissement(1));
                          handleFilterChange(filter.accessor, actif);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "natures_investissement_id":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        defaultValue={categorie}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(
                            setCategorieModeleInvestissement(e.target.value)
                          ),
                            dispatch(setCurrentPageModeleInvestissement(1));
                          handleFilterChange(filter.accessor, categorie);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );

                default:
                  return null;
              }
            })}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/publipostages_investissements?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&types_publipostage_id=${type}&actif=${actif}&natures_investissement_id=${categorie}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }

        const newData = await response.json();
        setModelInvestissement(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    handleFiltering();
  }, []);

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/publipostages_investissements?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&types_publipostage_id=${type}&actif=${actif}&natures_investissement_id=${categorie}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }

        // if (!response.ok) {
        //   setRedirect(true);
        //   throw new Error("La réponse du réseau n'est pas valide");
        // }
        dispatch(setCurrentPageModeleInvestissement(1));
        const newData = await response.json();
        setModelInvestissement(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    if (currentPage === 1) {
      handleFiltering();
    }
  }, [debounceSearch, type, actif, categorie]);
  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);
  return (
    <React.Fragment>
      {/* <DeleteModal
       show={deleteModal}
       onDeleteClick={}
       onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content">
        {previousPath ==
        `${backUrl}/publipostages_investissements/${lastId}/edit` ? (
          <LastModificationAlert path={"publipostages_investissements"} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title text-primary flex-grow-1">
                      Investissement (
                      {loading ? "--" : modelInvestissementData?.total_records})
                    </h5>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <Link
                        to={`${backUrl}/publipostages_investissements/new`}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="bx bx-plus"></i>Ajouter
                      </Link>
                      &nbsp; &nbsp;
                      {/* <Link to="#!" className="btn btn-sm btn-light me-1">
                        <i className="mdi mdi-export-variant"></i>Exporter
                      </Link> */}
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {!loading ? (
                    <>
                      <Row className="mb-3">{renderFilters()}</Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="table-responsive">
                    {!loading ? (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              {modelInvestissementData?.can_edit == false &&
                              modelInvestissementData?.can_show == false &&
                              modelInvestissementData?.can_destroy == false ? (
                                <th></th>
                              ) : (
                                <th
                                  style={{ cursor: "default" }}
                                  key="Action"
                                  className="text"
                                >
                                  Action
                                </th>
                              )}
                              {modelInvestissementData?.headers?.map(
                                ({ label, accessor, sortable }) => {
                                  const cl = sortable ? (
                                    sortField === accessor ? (
                                      order === "asc" ? (
                                        <i className="bx bx-up-arrow-alt"></i>
                                      ) : (
                                        <i className="bx bx-down-arrow-alt"></i>
                                      )
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  );
                                  return (
                                    <th
                                      key={accessor}
                                      onClick={
                                        sortable
                                          ? () => handleSortingChange(accessor)
                                          : null
                                      }
                                      className="text"
                                      style={{
                                        cursor: sortable
                                          ? "pointer"
                                          : "default",
                                      }}
                                    >
                                      {label}
                                      {cl}
                                    </th>
                                  );
                                }
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {modelInvestissementData?.data?.map(
                              (rowData, rowIndex) => (
                                <tr key={rowIndex}>
                                  <td key={rowIndex}>
                                    <ul className="list-unstyled hstack gap-1 mb-0">
                                      {modelInvestissementData?.can_show ? (
                                        <li
                                          data-bs-toggle="tooltip"
                                          data-bs-placement="top"
                                          title="View"
                                        >
                                          <Link
                                            className="btn btn-sm btn-soft-primary"
                                            id="viewtooltip-2"
                                            to={`${backUrl}/publipostages_investissements/${rowData.id}`}
                                          >
                                            <i className="mdi mdi-eye-outline"></i>
                                          </Link>
                                        </li>
                                      ) : null}
                                      {modelInvestissementData?.can_edit ? (
                                        <li title="Editer">
                                          <Link
                                            className="btn btn-sm btn-soft-info"
                                            id="edittooltip-2"
                                            to={`${backUrl}/publipostages_investissements/${rowData.id}/edit`}
                                            state={{ active: "details" }}
                                          >
                                            <i className="mdi mdi-pencil-outline"></i>
                                          </Link>
                                        </li>
                                      ) : null}
                                      {modelInvestissementData?.can_destroy ? (
                                        <li title="Supprimer">
                                          <DeleteButton
                                            url={`https://www.fluxod.com/${api}/publipostages_investissements/${rowData.id}`}
                                          />
                                        </li>
                                      ) : null}
                                    </ul>
                                  </td>
                                  {modelInvestissementData?.headers?.map(
                                    ({ label, accessor, sortable }) => (
                                      <>
                                        {rowData[accessor] === "Oui" ? (
                                          <td
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            <span
                                              className="bg-success badge bg-secondary"
                                              style={{ fontSize: "100%" }}
                                            >
                                              {rowData[accessor] || "——"}
                                            </span>
                                          </td>
                                        ) : rowData[accessor] === "Cloturée" ||
                                          rowData[accessor] === "Non" ? (
                                          <td
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            <span
                                              className="badge-soft-danger badge bg-secondary"
                                              style={{ fontSize: "100%" }}
                                            >
                                              {rowData[accessor] || "——"}
                                            </span>
                                          </td>
                                        ) : rowData[accessor] ===
                                            "En attente" ||
                                          rowData[accessor] ===
                                            "Commercialisation" ? (
                                          <td
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            <span
                                              className="bg-info badge bg-secondary"
                                              style={{ fontSize: "100%" }}
                                            >
                                              {rowData[accessor] || "——"}
                                            </span>
                                          </td>
                                        ) : label === "Investisseur" ? (
                                          <td
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            <a
                                              href={`${backUrl}/investisseurs/${rowData.investisseur_id}`}
                                            >
                                              <i className="bx bx-link"></i>
                                            </a>
                                            {rowData[accessor] || "——"}
                                          </td>
                                        ) : label === "Nom?" ? (
                                          <td
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            <a
                                              href={`${backUrl}/partenaires/${rowData.societe_id}`}
                                              className="underline"
                                              style={{ color: "#555B21" }}
                                            >
                                              {rowData[accessor] || "——"}
                                            </a>
                                          </td>
                                        ) : typeof rowData[accessor] ===
                                          "number" ? (
                                          <td
                                            className={"text-end"}
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            {rowData[accessor]
                                              .toLocaleString("fr-FR", {
                                                style: "currency",
                                                currency: "EUR",
                                              })
                                              .replace("€", "")}
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            {rowData[accessor] || "——"}
                                          </td>
                                        )}
                                      </>
                                    )
                                  )}
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <Spinners setLoading={setLoading} setWait={wait} />
                    )}
                  </div>
                </CardBody>
                <div className="d-flex justify-content-center mt-3">
                  {!loading ? (
                    <ReactPaginate
                      previousLabel={"<<"}
                      breakLabel={"..."}
                      nextLabel={">>"}
                      pageCount={modelInvestissementData.pages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={currentPage - 1}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default ModeleInvestissementList;
